import unescapedText from 'I18n/utils/unescapedText';
const getMetricLabel = (propertyLabel, metricType, fallback = '') => {
  if (!propertyLabel) {
    return fallback;
  }
  return unescapedText(`reporting-data.propertyLabel.${metricType.toUpperCase()}`, {
    propertyLabel
  });
};
export default getMetricLabel;